/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductCableList } from '../models/PaginatedProductCableList';
import type { PatchedProductCable } from '../models/PatchedProductCable';
import type { ProductCable } from '../models/ProductCable';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsCablesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductCableList
     * @throws ApiError
     */
    public productsCablesList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductCableList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-cables/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductCable
     * @throws ApiError
     */
    public productsCablesCreate({
        requestBody,
    }: {
        requestBody: ProductCable,
    }): CancelablePromise<ProductCable> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-cables/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductCable
     * @throws ApiError
     */
    public productsCablesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product cable.
         */
        id: number,
    }): CancelablePromise<ProductCable> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-cables/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductCable
     * @throws ApiError
     */
    public productsCablesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product cable.
         */
        id: number,
        requestBody: ProductCable,
    }): CancelablePromise<ProductCable> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-cables/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductCable
     * @throws ApiError
     */
    public productsCablesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product cable.
         */
        id: number,
        requestBody?: PatchedProductCable,
    }): CancelablePromise<ProductCable> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-cables/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsCablesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product cable.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-cables/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
